import { useAppSelector } from '@hooks/app/redux';
import { deleteProviderMerchants } from '@services/external/software-provider.api';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

function useDeleteSoftwareMerchant(options?: UseMutationOptions<void, unknown, string, unknown>) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useMutation(
    ['softwareProvider:delete', providerId],
    async (merchantId: string) => {
      await deleteProviderMerchants(providerId, merchantId);
    },
    options,
  );
}

export default useDeleteSoftwareMerchant;
